// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager-module--pager--1K9EE","previous":"pager-module--previous--2Gffi","next":"pager-module--next--kavk4","text":"pager-module--text--csuKA"};